// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SecretChatAccessRequest__container-c79343 {
  padding: 6px 16px;
  background-color: var(--base-0);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  border-bottom: 1px solid var(--base-20);
}

.SecretChatAccessRequest__content-b0341b {
  padding: 8px;
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
}

.SecretChatAccessRequest__icon-c6cab8 {
  background-color: var(--warning-40);
  color: var(--addition-50);
  padding: 4px;
  border-radius: 50%;
  margin-inline-end: 8px;
  min-width: 16px;
  fill: currentColor;
}

.SecretChatAccessRequest__username-fae7c7 {
  color: var(--base-80);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
}

.SecretChatAccessRequest__view-fe9340 {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/SecretChatAccessRequest/SecretChatAccessRequest.styles.m.css"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,uCAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,OAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,mCAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,qBAAA;EACA,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF","sourcesContent":[".container {\n  padding: 6px 16px;\n  background-color: var(--base-0);\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 52px;\n  border-bottom: 1px solid var(--base-20);\n}\n\n.content {\n  padding: 8px;\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  align-items: center;\n}\n\n.icon {\n  background-color: var(--warning-40);\n  color: var(--addition-50);\n  padding: 4px;\n  border-radius: 50%;\n  margin-inline-end: 8px;\n  min-width: 16px;\n  fill: currentColor;\n}\n\n.username {\n  color: var(--base-80);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n}\n\n.view {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SecretChatAccessRequest__container-c79343`,
	"content": `SecretChatAccessRequest__content-b0341b`,
	"icon": `SecretChatAccessRequest__icon-c6cab8`,
	"username": `SecretChatAccessRequest__username-fae7c7`,
	"view": `SecretChatAccessRequest__view-fe9340`
};
module.exports = ___CSS_LOADER_EXPORT___;
